(function ($, Cobalt, undefined) {
    Cobalt.TinyMCE = {
        dependentScripts: function() {
            return [
                { dependency: Cobalt.User, name: "Cobalt.User" }
            ];
        },
        fontColorEnabled: true,
        fontSizeEnabled: true,
        fontFamilyEnabled: true,
        textAlignmentEnabled: true,
        smiliesEnabled: true,
        initialized: false,
        loadAttempts: 0,
        extraPlugins: "",
        extraCustomPlugins: "", // comma-separated list
        extraButtons: "",
        extended_valid_elements: 'style',
        selector: "textarea[class*='j-wysiwyg-editor']", //any textarea with "j-wysiwyg-editor" in the class attribute
        optionsOverridden: false,
        forceSimpleBBCodeEditor: false,
        editors: {},
        options: {},
        //url: "", // is set in CobaltConstants.ascx
        //customPluginUrl: "", // is set in CobaltConstants.ascx
        //script_url: "", // is set in CobaltConstants.ascx

        setupPlaceholder: function(ed) {
            // Set placeholder
            var tinymcePlaceholder = $('#' + ed.id);
            var attr = tinymcePlaceholder.attr('placeholder');

            // For some browsers, `attr` is undefined; for others,
            // `attr` is false.  Check for both.
            if (typeof attr !== 'undefined' && attr !== false) {
                ed.placeholder = tinymcePlaceholder.attr("placeholder");

                ed.on("init", function (editor) {
                    // If its empty and we have a placeholder set the value
                    if (editor.getContent().length == 0) {
                        editor.setContent(tinymcePlaceholder.attr("placeholder"));
                        editor.placeholder = editor.getContent();
                    }
                });

                ed.on("init", function(editor) {
                    tinymce.dom.Event.add(editor.getBody(), 'focus', function() {
                        if (editor.getContent() == editor.placeholder) {
                            editor.setContent('');
                        }
                    });
                });

                ed.on("init", function(editor) {
                    tinymce.dom.Event.add(editor.getBody(), 'blur', function() {
                        if (editor.getContent().length == 0) {
                            editor.setContent(editor.placeholder);
                            editor.placeholder = editor.getContent();
                        }
                    });
                });
            }
        },
        initialize: function () {

            if (Cobalt.TinyMCE.initialized)
                return;

            Cobalt.TinyMCE.options.content_css = Cobalt.CMS.getTinyMCECss();
            Cobalt.runOnHtmlInsert(Cobalt.TinyMCE.loadTinyMCE);
            Cobalt.TinyMCE.initialized = true;
        },
        loadTinyMCE: function ($parent) {

            // load the appropriate options accoring to user prefs
            if (!Cobalt.TinyMCE.optionsOverridden) {
                var markupType = $parent.find(".j-markup-type").val();
                if (!markupType) {
                    markupType = $parent.parents(".j-comment").attr("data-markup-type");
                }
                if (markupType) {
                    switch (markupType) {
                        case "3":
                        case "7":
                            //bbcode
                            Cobalt.TinyMCE.bbcodeOptions();
                            break;
                        case "1":
                            //html
                        default:
                            {
                                Cobalt.TinyMCE.htmlOptions();
                                break;
                            }
                    }
                }
            }

            // find all the text areas that we need to replace in this parent
            var $editors = $parent.find('textarea.text-editor');
            if ($editors.length > 0) {
                if (!window.tinyMCE) {
                    //Found editors and add tinymce isn't loaded
                    var fileref = document.createElement('script');

                    fileref.onload = function () {
                        //loaded tinymce script and execute on load.
                        if (window.tinyMCE) {
                            Cobalt.TinyMCE._actuallyLoadTinyMCE($editors);
                        }
                    };

                    fileref.setAttribute("type", "text/javascript");
                    fileref.setAttribute("src", Cobalt.TinyMCE.url);

                    if (typeof fileref != "undefined") {
                        document.getElementsByTagName("head")[0].appendChild(fileref);
                    }
                }
                else {
                    //Found editors and add tinymce has already been loaded
                    Cobalt.TinyMCE._actuallyLoadTinyMCE($editors);
                }
            }
        },
        _actuallyLoadTinyMCE: function ($editors) {
            // make sure that we have tinymce
            if (window.tinyMCE) {
                $.log("Initializing tinymce editor(s).");

                // ***** NOTE: next line needs to be here if tinymce is local, but commented out if loading from CDN
                //window.tinyMCE.EditorManager.baseURL = tinymce.EditorManager.documentBaseURL = document.location.protocol + "//" + document.location.host + "/content/js/tinymce/tiny_mce";

                $editors.each(function() {
                    // try to get from the editor manager
                    var id = $(this).attr("id");
                    var editor = window.tinymce.EditorManager.get(id);

                    // NOTE: it can create problems if an editor is initialized more than once. we have seen behavior where
                    // multiple editors are added for a single editor. tinymce doesn't care that it's already created an editor
                    // to replace the textarea - it just does it again. instead of globally initializing editors as we used to do,
                    // we now explicitly create each editor

                    // see if the editor already exists
                    if (!editor) {
                        // doesn't exist yet, initialize
                        var options = Cobalt.TinyMCE.options;
                        delete options.selector;

                        // NOTE: the following method was used to create the new editor instead of
                        // var editor = window.tinymce.EditorManager.createEditor(id, options);
                        // That method was producing the side effect of creating 2-editors every time instead of one
                        editor = new tinymce.Editor(id, options, tinymce.EditorManager); // create editor and add it to the manager
                        editor.render(); // draw it

                        $.log("Called render for tinymce editor: " + id);
                    }
                });
            }
        },
        removeEditor: function ($element) {
            ///<summary>Removes the tinymce editor from the element if there is one.</summary>
            var textArea = $element.find(Cobalt.TinyMCE.selector);
            var editorId = textArea.attr("id");
            var editor = Cobalt.TinyMCE.editors[editorId];
            if (editor) {
                editor.remove();
                editor.destroy();
                delete Cobalt.TinyMCE.editors[editorId];
            }
        },
        _enableBlockQuoteBreakout: function(editor) {
            // listen for down arrow when the last element is inside a blockquote
            // and append a <br/> to the body . this will allow us to easily break
            // out of the blockquote without having to double-enter
            tinymce.dom.Event.bind(editor.getBody(), 'keydown', function (e) {
                if (e.which == 40) {// only do something if it's the down arrow
                    // see if the last element is inside of a blockquote
                    var $lastElementAncestors = $(editor.getBody()).find(":last").parentsUntil("body");
                    if ($lastElementAncestors.is("blockquote")) {
                        //$.log(e);
                        // add a default tinymce last element
                        $(editor.getBody()).append("<br data-mce-bogus=\"1\" />");
                    }
                }
            });
        },
        _addExtraPlugins: function(pluginConfig) {
            ///<summary>Adds site-configured plugins to the plugin config and returns the config. These
            /// plugins must be default tinymce plugins listed here: http://www.tinymce.com/wiki.php/Plugins </summary>
            if (Cobalt.TinyMCE.extraPlugins != "" && Cobalt.TinyMCE.extraPlugins != null) {
                pluginConfig += "," + Cobalt.TinyMCE.extraPlugins;
            }

            return pluginConfig;
        },
        _addExtraCustomPlugins: function (plugins) {
            ///<summary>Adds site-configured plugins to the external_plugins config and returns the config.
            /// We are expecting a comma-separated list for <paramref name="plugins"/>. We will add a config
            /// property for each of these and set the path to [custompluginpath]/[pluginName]/plugin.js</summary>

            var pluginArray = $(plugins.split(","));
            var config = {
                // example: "pluginName": "/path/to/plugin.js",
            };

            pluginArray.each(function() {
                config[this] = Cobalt.TinyMCE.customPluginUrl + "/" + this + "/plugin.js";
            });

            // add the plugins defined in the constants
            if (Cobalt.TinyMCE.extraCustomPlugins !== undefined && Cobalt.TinyMCE.extraCustomPlugins !== '') {
                var configurablePluginArray = $(Cobalt.TinyMCE.extraCustomPlugins.split(','));
                configurablePluginArray.each(function() {
                    if (!config[this]) {
                        // add it if it's not already added
                        config[this] = Cobalt.TinyMCE.customPluginUrl + "/" + this + "/plugin.js";
                    }
                });
            }

            return config;
        },
        _addExtraButtons: function(toolBarConfig) {
            ///<summary>Adds and configured extra buttons to the toolbarconfig and returns the config.</summary>
            if (Cobalt.TinyMCE.extraButtons != "" && Cobalt.TinyMCE.extraButtons != null) {
                toolBarConfig += ",|," + Cobalt.TinyMCE.extraButtons;
            }

            return toolBarConfig;
        },
        _removeDisabledControls: function(toolBarConfig) {
            ///<summary>Removes disabled controls from a toolbarconfig and returns the config.</summary>
            if (!Cobalt.CMS.initialized) {
                // the regex patterns below should match a space or comma delimited configuration
                // the replace should just gobble the match and the preceding space/comma (if there is one)
                if (!Cobalt.TinyMCE.fontColorEnabled) {
                    toolBarConfig = toolBarConfig.replace(/(\s*|,?)forecolor/g, "");
                }

                if (!Cobalt.TinyMCE.fontFamilyEnabled) {
                    toolBarConfig = toolBarConfig.replace(/(\s*|,?)fontselect/g, "");
                }

                if (!Cobalt.TinyMCE.fontSizeEnabled) {
                    toolBarConfig = toolBarConfig.replace(/(\s*|,?)fontsizeselect/g, "");
                }

                if (!Cobalt.TinyMCE.smiliesEnabled) {
                    toolBarConfig = toolBarConfig.replace(/(\s*|,?)smilies/g, "");
                }

                if (!Cobalt.TinyMCE.textAlignmentEnabled) {
                    toolBarConfig = toolBarConfig.replace(/(\s*|,?)alignleft/g, "");
                    toolBarConfig = toolBarConfig.replace(/(\s*|,?)aligncenter/g, "");
                    toolBarConfig = toolBarConfig.replace(/(\s*|,?)alignright/g, "");
                }
            }

            return toolBarConfig;
        },
        tinyMCELoaded: function (editor) {

            if (editor) {
                var editorId = editor.id;
                var tinymce = editor.target;
                if (tinymce) {
                    var currentEditor = undefined;
                    if (tinymce.editors) {
                        for (var i = 0; i < tinymce.editors.length; i++) {
                            if (tinymce.editors[i].id === editorId && $("#" + editorId).hasClass("j-wysiwyg-editor")) {
                                currentEditor = tinymce.editors[i];
                                break;
                            }
                        }
                    }
                    if (currentEditor) {
                        Cobalt.TinyMCE.editors[currentEditor.id] = currentEditor;
                        // using jQuery as a generic event bus here
                        // fire an EditorLoaded event
                        var editorLoadedEvent = $.Event("EditorLoaded", { editor: currentEditor });
                        $(Cobalt.TinyMCE).trigger(editorLoadedEvent);
                    }
                }

                $(editor.getElement()).parents(".j-loading-message").removeClass("unloaded");
            }

        },
        focusEditor: function (editor) {
            editor.focus();
            editor.selection.select(editor.getBody(), true);
            editor.selection.collapse(false);
            var editorContent = $(editor.getDoc());
            editorContent.scrollTop(editorContent.height());
        },
        unload: function () {
            if (typeof (tinyMCE) !== 'undefined') {
                tinymce.each(tinyMCE.editors, function (e) {
                    if (typeof (e) !== 'undefined') {
                        tinyMCE.execCommand("mceRemoveControl", false, e.id);
                        tinymce.remove(e);
                    }
                });
            }
        },
        htmlOptions: function() {
            Cobalt.TinyMCE.options = {
                skin_url: Cobalt.TinyMCE.skin_url,
                setup: function (ed) {
                    Cobalt.TinyMCE.setupPlaceholder(ed);

                    ed.on("init", function (evt) {
                        var editor = evt.target;

                        Cobalt.TinyMCE._enableBlockQuoteBreakout(editor);

                        tinymce.dom.Event.bind(editor.getBody(), 'focus', function () {
                            $(document).trigger('tinymce-focus', $('#' + editor.id));
                        });

                        $("#" + editor.id + "_blockquote").on("click", function () {
                            editor.dom.add(editor.getBody(), 'p', null, '<br />');
                        });

                        Cobalt.TinyMCE.tinyMCELoaded(editor);
                    });
                },
                doctype: '<!DOCTYPE html>',
                // the next setting allows the user to hit enter twice to break out of blockquotes
                // this doesn't seem to work for pre tags. for that you have to shift+enter
                end_container_on_empty_block: true,
                body_class: "text u-typography-format",
                content_css: Cobalt.CMS.getTinyMCECss(),
                selector: Cobalt.TinyMCE.selector,
                menubar: false,
                height: "250px",
                width: "100%",
                formats: {
                    bold: { inline: 'strong' },
                    italic: { inline: 'em' },
                    strikethrough: { inline: 'del' },
                    address: { inline: 'addr' },
                    removeformat: [
                    {
                        selector: 'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del',
                        remove: 'all',
                        split: true,
                        expand: false,
                        block_expand: true,
                        deep: true
                    },
                    { selector: 'span', attributes: ['style', 'class'], remove: 'empty', split: true, expand: false, deep: true },
                    { selector: '*', attributes: ['style', 'class'], split: false, expand: false, deep: true }
                    ]
                },
                // plugins + any that are site-configured
                plugins: Cobalt.TinyMCE._addExtraPlugins("code,hr,image,link,lists,media,paste,tabfocus,textcolor"),
                external_plugins: Cobalt.TinyMCE._addExtraCustomPlugins("smilies,spoiler,videoembed,codeBlock,dieroller"),
                tabfocus_elements: "field-submit",
                dialog_type: "modal",
                extended_valid_elements: "iframe[allowfullscreen|src|height|width]",
                // removing any disabled controls and adding any site-configured buttons to this toolbar
                // be very cafeful when altering this list. all items (including the '|' seperator) must have the delimiter
                // seperating them. this list can be comma or space-delimited, but for consistency make it commas since _addExtraButtons uses commas.
                // also adding any site-configured buttons to this toolbar
                toolbar: Cobalt.TinyMCE._addExtraButtons(Cobalt.TinyMCE._removeDisabledControls("undo,|,paste,|,bold,|,italic,|,underline,|,strikethrough,|,blockquote,|,code,"
                    + "|,formatselect,|,alignleft,|,aligncenter,|,alignright,|,fontselect,|,fontsizeselect,|,forecolor,|,bullist,|,numlist,"
                    + "|,hr,|,removeformat,|,outdent,|,indent,|,spoiler,|,link,|,unlink,|,image,|,videoembed,|,smilies,|,codeBlock,|,dieroller")),
                relative_urls: false,
                block_formats: "Paragraph=p;Header 2=h2;Header 3=h3;Header 4=h4;Header 5=h5;Header 6=h6;Pre=pre;",
                fontsize_formats: "8px 10px 12px 14px 18px 24px 36px",
                paste_auto_cleanup_on_paste: true,
                paste_remove_styles: true,
                paste_remove_styles_if_webkit: true,
                paste_strip_class_attributes: "all",
                paste_block_drop: true,
                gecko_spellcheck: true,
                forced_root_block: "p",
                schema: "html5",
                remove_script_host: false,
                media_live_embeds: false
            };
        },
        bbcodeOptions: function () {
            Cobalt.TinyMCE.options = {
                skin_url: Cobalt.TinyMCE.skin_url,
                setup: function (ed) {
                    Cobalt.TinyMCE.setupPlaceholder(ed);

                    ed.on("init", function (evt) {
                        var editor = evt.target;

                        Cobalt.TinyMCE._enableBlockQuoteBreakout(editor);

                        tinymce.dom.Event.bind(editor.getBody(), 'focus', function () {
                            $(document).trigger('tinymce-focus', $('#' + ed.id));
                        });

                        if (Cobalt.TinyMCE.forceSimpleBBCodeEditor) {
                            editor.buttons.hideeditor.onclick();
                            if ($("#" + editor.id).val() === "[p][/p]") {
                                $("#" + editor.id).html("");
                            }
                        }

                        $("#" + editor.id + "_blockquote").on("click", function () {
                            editor.dom.add(editor.getBody(), 'p', null, '<br />');
                        });

                        Cobalt.TinyMCE.tinyMCELoaded(editor);
                    });
                },
                doctype: '<!DOCTYPE html>',
                // the next setting allows the user to hit enter twice to break out of blockquotes
                // this doesn't seem to work for pre tags. for that you have to shift+enter
                end_container_on_empty_block: true,
                selector: Cobalt.TinyMCE.selector,
                menubar: false,
                body_class: "text u-typography-format",
                content_css: Cobalt.CMS.getTinyMCECss(),
                height: "250px",
                width: "100%",
                // plugins + any that are site-configured
                plugins: Cobalt.TinyMCE._addExtraPlugins("code,hr,image,link,lists,media,paste,tabfocus,textcolor"),
                external_plugins: Cobalt.TinyMCE._addExtraCustomPlugins("CobaltHideEditor,CobaltBBCode,smilies,spoiler,videoembed,codeBlock"),
                tabfocus_elements: "field-submit",
                dialog_type: "modal",
                formats: {
                    strikethrough: { inline: 'del' },
                    removeformat: [
                   {
                       selector: 'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del',
                       remove: 'all',
                       split: true,
                       expand: false,
                       block_expand: true,
                       deep: true
                   },
                   { selector: 'span', attributes: ['style', 'class'], remove: 'empty', split: true, expand: false, deep: true },
                   { selector: '*', attributes: ['style', 'class'], split: false, expand: false, deep: true }
                    ]
                },
                extended_valid_elements: "section,u",
                // removing any disabled controls and adding any site-configured buttons to this toolbar
                // be very careful when altering this list. all items (including the '|' separator) must have the delimiter
                // separating them. this list can be comma or space-delimited, but for consistency make it commas since _addExtraButtons uses commas.
                // also adding any site-configured buttons to this toolbar
                toolbar1: Cobalt.TinyMCE._addExtraButtons(Cobalt.TinyMCE._removeDisabledControls("undo,|,removeformat,|,formatselect,|,fontselect,|,fontsizeselect,|,forecolor,"
                    + "|,alignleft,|,aligncenter,|,alignright,|,bullist,"
                    + "|,numlist,|,outdent,|,indent,"
                    + "|,bold,|,italic,|,underline,|,strikethrough,|,subscript,|,superscript,"
                    + "|,blockquote,|,image,|,spoiler,|,link,|,unlink,|,smilies,|,codeBlock,|,hideeditor")),
                relative_urls: false,
                block_formats: "Paragraph=p;Header 2=h2;Header 3=h3;Header 4=h4;Header 5=h5;Header 6=h6;Pre=pre;",
                fontsize_formats: "8px 10px 12px 14px 18px 24px 36px",
                paste_auto_cleanup_on_paste: true,
                paste_remove_styles: true,
                paste_remove_styles_if_webkit: true,
                paste_strip_class_attributes: "all",
                paste_block_drop: true,
                gecko_spellcheck: true,
                forced_root_block: "p",
                schema: "html5",
                remove_script_host: false,
                media_live_embeds: false
            };
        },
        getEditorFromForm: function (commentForm, callback) {
            ///<summary>This function invokes the <paramref name="callback"/> with
            /// the tinymce editor that belongs to the <paramref name="commentForm"/> after the editor
            /// has been initialized and our "oninit" functions have already run.
            /// It will also return the editor if it was found synchronously or undefined if it was not.
            /// NOTE: We are only expecting one editor per form here.
            ///</summary>

            // try to get the form's editor id
            var $textArea = commentForm.find("textarea.text-editor");

            var id = $textArea.attr("id");

            // try to get the editor
            var editor = Cobalt.TinyMCE.editors[id];

            if (editor) { // the editor has already been initalized
                if (callback) { // don't try to call the fx if there isn't one
                    callback(editor);
                }
            } else { // the editor hasn't been initialized yet
                // wait for it - using jQuery as a generic event bus here
                $(Cobalt.TinyMCE).on("EditorLoaded",function(args) {
                    if (args.editor.id === id) {
                        callback(args.editor);
                    }
                });
            }

            // this sends a bit of a mixed message for how to use this function
            // but there are some cases where we need to know if the editor is available
            // in a synchronous manner. so, we will return what we have here.
            return editor;
        },
        saveEditorInForm: function (commentForm) {
            ///<summary>This function saves the editor in the form if one was found synchronously.</summary>
            var editor = Cobalt.TinyMCE.getEditorFromForm(commentForm);

            if (editor) {
                editor.save();
            }
        }
    };
})(jQuery, Cobalt);



// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.TinyMCE.js